import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical, TextP } from '../../..';

interface Props {
  password: string;
}

function PasswordMeter(props) {
  const { password } = props;
  let numOfIndicators = 0;
  let is1Active = false;
  let is2Active = false;
  let is3Active = false;
  let is4Active = false;
  let is5Active = false;
  let text = 'Žiadne heslo';

  const passwordLength = password.length;
  const lowerCase = /[a-z]/g;
  const upperCase = /[A-Z]/g;
  const numbers = /[0-9]/g;
  const symbols = /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g;

  const hasCharacterFrom = characters => {
    return password.match(characters);
  };

  const changeIndicators = () => {
    if (numOfIndicators > 0) {
      is1Active = true;
      text = 'Slabé heslo';
      if (numOfIndicators > 1) {
        is2Active = true;
        if (numOfIndicators > 2) {
          is3Active = true;
          text = 'Dobré heslo';
          if (numOfIndicators > 3) {
            is4Active = true;
            if (numOfIndicators > 4) {
              is5Active = true;
              text = 'Silné heslo';
            }
          }
        }
      }
    }
  };

  if (hasCharacterFrom(lowerCase)) {
    numOfIndicators++;
    changeIndicators();
  }

  if (passwordLength > 6) {
    numOfIndicators++;
    changeIndicators();
  }

  if (hasCharacterFrom(upperCase)) {
    numOfIndicators++;
    changeIndicators();
  }

  if (hasCharacterFrom(numbers)) {
    numOfIndicators++;
    changeIndicators();
  }

  if (hasCharacterFrom(symbols)) {
    numOfIndicators++;
    changeIndicators();
  }

  return (
    <>
      <Wrapper>
        <Indicators>
          <Indicator isActive={is1Active} numOfActive={numOfIndicators} />
          <Indicator isActive={is2Active} numOfActive={numOfIndicators} />
          <Indicator isActive={is3Active} numOfActive={numOfIndicators} />
          <Indicator isActive={is4Active} numOfActive={numOfIndicators} />
          <Indicator isActive={is5Active} numOfActive={numOfIndicators} />
        </Indicators>
        <Text>{`${text}`}</Text>
      </Wrapper>
    </>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  margin-top: ${rem(16)};
`;

const Indicators = styled(FlexRowCenterVertical)``;

const Indicator = styled.div<{ isActive: boolean; numOfActive: number }>`
  background-color: ${({ theme, isActive, numOfActive }) =>
    !isActive
      ? theme.colors.lightGray
      : numOfActive < 3
      ? theme.colors.dangerColor
      : numOfActive < 5
      ? theme.colors.middleColor
      : theme.colors.successColor};
  width: ${rem(16)};
  height: ${rem(4)};
  margin-right: ${rem(4)};
`;

const Text = styled(TextP)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.inactiveFontColor};
`;

export { PasswordMeter as DsiPasswordMeter };
